import globe from "../../../assets/globe.png";
import { TCText } from "../../../components/tcText/TCText";
import { Colors } from "../../../utils/colors";
import locPin from "../../../assets/locPin.png";
import { MatchResponsePayload } from "../../../apis/types";
import { useMemo } from "react";
import { formatDateTime } from "../../../utils/utils";
import { LeagueLevel } from "../../../utils/typeValues";

type props = {
  match: MatchResponsePayload;
};

export const MatchHeader: React.FC<props> = ({ match }) => {
  const dateTime = useMemo(
    () => (match.date ? formatDateTime(match.date) : "-"),
    [match.date]
  );

  const level = useMemo(() => {
    return match.level === LeagueLevel.Low
      ? "Low"
      : match.level === LeagueLevel.Intermediate
      ? "Intermediate"
      : "High";
  }, [match.level]);

  return (
    <div
      style={{
        width: "100%",
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: Colors.darkBrown,
        borderRadius: 16,
      }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={globe} alt="globe" style={{ width: 32, height: 32 }} />
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <TCText
              value={"Match"}
              style={{
                fontWeight: 600,
                fontSize: 12,
                color: Colors.white,
              }}
            />
            {match.teamA ? (
              <img
                src={match.teamA.countryImageUrl}
                alt="globe"
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                }}
              />
            ) : null}
            {match.teamA && match.teamB ? (
              <TCText
                value={"vs"}
                style={{
                  fontWeight: 600,
                  fontSize: 12,
                  color: Colors.white,
                }}
              />
            ) : null}
            {match.teamB ? (
              <img
                src={match.teamB.countryImageUrl}
                alt="globe"
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                }}
              />
            ) : null}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <TCText
            value={dateTime.includes(",") ? dateTime.split(",")[0] : ""}
            style={{ fontSize: 10, fontWeight: 600, color: Colors.white }}
          />
          <div
            style={{ height: 15, width: 1, backgroundColor: Colors.white }}
          />
          <TCText
            value={dateTime.includes(",") ? dateTime.split(",")[1] : ""}
            style={{ fontSize: 10, fontWeight: 600, color: Colors.white }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginLeft: 40,
          marginTop: 10,
        }}>
        <TCText
          value={level}
          style={{
            fontWeight: 500,
            fontSize: 10,
            color: Colors.white,
          }}
        />
        {match.locationName ? (
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <img src={locPin} alt="locPin" style={{ width: 12, height: 12 }} />
            <TCText
              value={match.locationName ?? ""}
              style={{
                fontWeight: 500,
                fontSize: 10,
                color: Colors.white,
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
